import { render, staticRenderFns } from "./developerDashboardCard.vue?vue&type=template&id=b39493d0&"
import script from "./developerDashboardCard.vue?vue&type=script&lang=js&"
export * from "./developerDashboardCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports